import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import YourActivity from "./YourActivity";

const AccountSection = ({
  referFriendRef,
  waysToRedeemRef,
  waysToEarnRef,
  merchantData,
  customerData,
  appStateData,
}) => {
  const { customer } = customerData;
  const { merchant } = merchantData;
  let { shopDomain } = appStateData;
  const isGermanLang = shopDomain === "nui-cosmetics.myshopify.com";
  const [isMyActivity, setIsMyActivity] = useState(false);

  return (
    <Fragment>
      <div className="accountSection-wrapper">
        <div className="customer-greeting-container">
          <h1 className="customer-greeting-text">
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.heyCustomerName?.replace(
                  "{{customer_name}}",
                  customer?.name?.split(" ")?.[0] ?? "Customer"
                )
              : ` Hey ${customer?.name?.split(" ")?.[0] ?? "Customer"}!`}
          </h1>
        </div>
        {(merchant?.isPointsActive || merchant?.isVipTiersActive) && (
          <div className="customer-details-container">
            {merchant?.isPointsActive && (
              <h3 className="customer-points-details">
                {isGermanLang
                  ? "Deine Punkte:"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.youHavePoints?.replace(
                      "{{points}}",
                      customer?.points ?? 0
                    )
                  : "Your Point Balance:"}{" "}
                {customer?.points ?? 0}
              </h3>
            )}
            {merchant?.isVipTiersActive && customer?.tierName && (
              <h3 className="customer-vip-tier-details">
                {isGermanLang
                  ? "Dein Status"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.currentTier
                  : "Current VIP Tier:"}{" "}
                {customer?.tierName ?? "-"}
              </h3>
            )}
          </div>
        )}
        <div className="customer-buttons-container">
          {(merchant?.isPointsActive || merchant?.isGiftcardsActive) && (
            <button
              onClick={() => {
                merchant?.isPointsActive
                  ? waysToRedeemRef.current.scrollIntoView({
                      behavior: "smooth",
                    })
                  : waysToEarnRef.current.scrollIntoView({
                      behavior: "smooth",
                    });
              }}
              className="customer-primary-button"
            >
              {merchant?.isPointsActive
                ? merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemNow
                  : "Redeem Now"
                : merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                ? merchant?.customWidgetTheme?.textCustomization?.earnGiftCards
                : "Earn Gift Cards"}
            </button>
          )}
          {merchant?.isReferralsActive && (
            <button
              onClick={() => {
                referFriendRef.current.scrollIntoView({ behavior: "smooth" });
              }}
              className="customer-primary-button customer-secondary-button"
            >
              {isGermanLang
                ? "NUI weiterempfehlen"
                : merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                ? merchant?.customWidgetTheme?.textCustomization
                    ?.referYourFriends
                : "Refer a Friend"}
            </button>
          )}
          <button
            onClick={() => {
              setIsMyActivity((prev) => !prev);
              setTimeout(() => {
                window.parent.frames.postMessage(
                  { height: document.body.scrollHeight },
                  "*"
                );
              }, 500);
            }}
            className="customer-primary-button customer-secondary-button"
            style={{
              opacity: isMyActivity ? 0.5 : 1,
            }}
          >
            {isGermanLang
              ? "Deine letzten Aktivitäten"
              : merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.yourActivity
              : "Your Activity"}
          </button>
        </div>
      </div>
      {isMyActivity && <YourActivity />}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  appStateData: state.AppstateReducer,
  merchantData: state.MerchantReducer,
  customerData: state.CustomerReducer,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AccountSection);
